import React, { useEffect, useMemo, useState } from 'react';
import style from "./index.module.scss"
import { Order } from '../../../services';
import { toast } from 'react-toastify';

import CloseIcon from "../../shared/icons/CloseIcon";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import SelectCustom from "../../shared/forms/select-custom";
import InputCustom from "../../shared/forms/input-custom";
import { useSelector } from 'react-redux';
import {t} from "i18next";

const AddYourCity = ({
  setCountry,
  setCity,
  countries,
  country,
  setIsСallСities,
  setAddedCityId,
  isOpenAdd,
  setIsOpenAdd,
}) => {
  const { user } = useSelector(state => state);
  const [cityName, setCityName] = useState();
  const [cities, setCities] = useState([]);

  const handleClose = () => {
    setIsOpenAdd(false);
  }

  const fetchCities = async (countryId) => {
    try {
      const response = await Order.getCities(countryId, user.id);
      setCities(response.data);
    } catch (error) {
      console.error('Ошибка при получении городов:', error);
    }
  };

  useEffect(() => {
    if (cityName) {
      fetchCities(country.id);
      // console.log("получении городов:", cities)
    }
  }, [cityName]);

  const addCityToServer = async () => {

    const existingCity = cities.find(city => city.name.toLowerCase() === cityName.toLowerCase());
    if (existingCity) {
      toast.error("Город уже имеется в списке - выберите из Справочника");
      return;
    }

    try {
      const response = await Order.getAddYourCity({
        countryId: country.id,
        name: cityName,
      });

      setIsСallСities(true)
      console.log(response)
      handleClose();
      setCityName('');
      setAddedCityId(response.data)
      toast.info("Город успешно добавлен");
    } catch (error) {
      console.error('Ошибка при добавлении города:', error);
    }
  };

  return (
    <>
      {isOpenAdd &&
        <div className="modal-overlay">
          <div className={style.modal}>
            <div style={{
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}>
              <CloseIcon width={20} height={20} onClick={() => { handleClose() }} fill={'#909195'}
                style={{
                  position: 'absolute',
                  top: "-15px",
                  right: "-15px",
                }} />
              <div className={style.title}>
                Добавьте новый город
              </div>
              <span className={style.titleSub}>
                Новый город нужно добавить в том случае, <br></br> если нет вашего города в списке
              </span>
              <div style={{ marginTop: "20px", }}>
                <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.country')}>
                  <SelectCustom
                    key={'countries-from'}
                    placeholder={t('chooseCountry')}
                    options={countries}
                    defaultValue={country}
                    returnObject
                    onSubmit={(item) => {
                      setCountry(item);
                      setCity(null);
                    }}
                  />
                </OrdersSectionItemInfoColumn>
              </div>
              <div style={{ marginTop: "14px", }}>
                <OrdersSectionItemInfoColumn title="Город">
                  <InputCustom
                    placeholder={'Введите город'}
                    inputType="text"
                    defaultValue={setCityName}
                    onChangeValue={(item) => {
                      setCityName(item);
                    }}
                  />
                </OrdersSectionItemInfoColumn>
              </div>
            </div>
            <button className={style.btn} style={{ width: '200px', marginTop: '20px' }} onClick={addCityToServer}>Добавить</button>
          </div>
        </div >
      }
    </>

  );
};

export default AddYourCity;